import { CDN_IMAGES_URL } from '../../config';
import { RecallCompatibleMeetingTools } from '@waitroom/models';

export const providers: Record<RecallCompatibleMeetingTools, string> = {
  google: `${CDN_IMAGES_URL}/gmeet.png`,
  microsoft: `${CDN_IMAGES_URL}/msteams.png`,
  zoom: `${CDN_IMAGES_URL}/zoom.png`,
};
